import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["remainingTags", "toggleTagsLink"];

  toggleTagView(event) {
    let see_more_text = event.target.dataset.tagMoreValue;
    let see_less_text = event.target.dataset.tagLessValue;

    if (this.remainingTagsTarget.style.display === "none") {
      this.remainingTagsTarget.style.display = "block";
      this.toggleTagsLinkTarget.innerText = see_less_text;
    } else {
      this.remainingTagsTarget.style.display = "none";
      this.toggleTagsLinkTarget.innerText = see_more_text;
    }
  }
}
